<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md6>
        <material-card>
          <v-card-text class="text-center">
            <h3>We can't find your team ;(</h3>
            <p class="category mb-3">
              Sorry, it looks like your account isn't part of any teams. Please contact your Team Manager to get added to a team.
              If you are not a Jig Pro user and would like to become one, please get in touch with us at contact@jig.space.
            </p>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script lang="js">
export default {
  data() {
    return {
      profile: this.$auth.profile,
    };
  },
  methods: {
    handleLoginEvent(data) {
      this.profile = data.profile;
    },
  },
};
</script>
